import React, { useState } from "react";
import PropTypes from "prop-types";
// ui
import Button from "@mui/material/Button";
// style
import { createStyles, makeStyles, styled } from "@material-ui/styles";
import classNames from "classnames";
// config

// useStyle
const useStyles = makeStyles((theme) =>
  createStyles({
    root: {},
  })
);

// basic style
const StyledButton = styled(Button)(({ theme }) => ({
  width: "240px",
  height: "32px",
  padding: "9px 12px",
  borderRadius: "4px",
  // position: "relative",
  "&.MuiButton-root": {},
  "&.MuiButton-contained": {},
  "& .MuiButton-startIcon": {
    // position: "absolute",
    // left: "15px",
  },
}));

// fullWidth or custom width
const StyledButtonFlexible = styled(Button)(({ theme }) => ({
  height: "32px",
  padding: "9px 12px",
  borderRadius: "4px",
  // position: "relative",
  "&.MuiButton-root": {},
  "&.MuiButton-contained": {},
  "& .MuiButton-startIcon": {
    // position: "absolute",
    // left: "15px",
  },
}));

//
const ButtonBasic = ({ text, fullWidth, customWidth, ...rest }) => {
  // style
  const classes = useStyles();
  // props
  const { className } = rest;
  // local state

  //
  if (fullWidth || customWidth) {
    return (
      <StyledButtonFlexible
        variant="contained"
        fullWidth={fullWidth === true}
        {...rest}
        className={classNames(className)}
      >
        {text}
      </StyledButtonFlexible>
    );
  }
  return (
    <StyledButton
      variant="contained"
      {...rest}
      className={classNames(className)}
    >
      {text}
    </StyledButton>
  );
};

ButtonBasic.propTypes = {
  text: PropTypes.string,
  fullWidth: PropTypes.bool,
  customWidth: PropTypes.bool,
};

ButtonBasic.defaultProps = {
  text: "click me",
  fullWidth: false,
  customWidth: false,
};

export default ButtonBasic;
